import dayjs from "dayjs";
import "dayjs/locale/nb";

dayjs.locale("nb");

export function formatDatePeriod(from, to) {
  const fromDate = dayjs(from);
  const toDate = dayjs(to);
  const format = "D. MMMM YYYY";
  const timeFormat = "[kl.] HH:mm";
  const fromFormatSameDay = `${fromDate.format(format)} <br />${fromDate.format(timeFormat)}`;

  if (fromDate.isSame(toDate, "day")) {
    return `${fromFormatSameDay}–${toDate.format(timeFormat)}`;
  } else {
    const fromFormatMultiDay = `${fromDate.format(format)} ${fromDate.format(timeFormat)}`;
    const toFormat = `${toDate.format(format)} ${toDate.format(timeFormat)}`;
    return `${fromFormatMultiDay} - <br />${toFormat}`;
  }
}

export function formatDate(date) {
  const dateObj = dayjs(date);
  const format = "dddd D. MMMM, YYYY [kl.] HH:mm";
  return dateObj.format(format);
}

export function formatPublishDate(date) {
  const dateObj = dayjs(date);
  const format = "D. MMMM YYYY";
  return dateObj.format(format);
}
